module.exports = __webpack_public_path__ + "static/img/6606_phase_function_Paper_PointsHejduk_Prediction.67df767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6606_phase_function_Paper_PointsHejduk_Prediction.png
// module id = FFIj
// module chunks = 0